import { __assign } from "tslib";
var Button = /** @class */ (function () {
    function Button(dto) {
        this.dto = __assign({}, dto);
    }
    Object.defineProperty(Button.prototype, "cta", {
        get: function () {
            return this.dto.cta;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Button.prototype, "payload", {
        get: function () {
            return this.dto.payload;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Button.prototype, "text", {
        get: function () {
            return this.dto.text;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Button.prototype, "type", {
        get: function () {
            return this.dto.type;
        },
        enumerable: false,
        configurable: true
    });
    Button.buildButton = function (params) { return new Button(params); };
    return Button;
}());
export default Button;
